var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1354 0C1.41118 0 0 1.41114 0 3.1354V12.8651C0 14.5893 1.41114 16 3.1354 16H12.8651C14.5894 16 16 14.5894 16 12.8651V3.1354C16 1.41118 14.5894 0 12.8651 0H3.1354ZM3.924 2.64032C4.75073 2.64032 5.25996 3.18306 5.27568 3.89647C5.27568 4.59414 4.7507 5.15212 3.90801 5.15212H3.8925C3.08151 5.15212 2.55733 4.59417 2.55733 3.89647C2.55733 3.18307 3.09737 2.64032 3.92399 2.64032H3.924ZM11.0484 5.97474C12.6384 5.97474 13.8303 7.01394 13.8303 9.24714V13.4162H11.4139V9.52666C11.4139 8.54927 11.0642 7.88245 10.1898 7.88245C9.52224 7.88245 9.12434 8.3319 8.94964 8.76607C8.88582 8.9214 8.87013 9.13834 8.87013 9.35564V13.4162H6.45383C6.45383 13.4162 6.48554 6.82746 6.45383 6.14525H8.87063V7.17488C9.19173 6.67946 9.76609 5.97472 11.0484 5.97472V5.97474ZM2.69985 6.14577H5.11616V13.4162H2.69985V6.14577Z",
    fill: "#0077B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.eb0a32d66ca00feacf012af58f94b556.svg";
export { ForwardRef as ReactComponent };